import { FinancialCasesList } from './FinancialCasesList';
import { FinancialFilter } from './FinancialFilter';
import { usePathname, useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
import { useQuery } from '@tanstack/react-query';
import { financialRecoveryService, GET_RECOVERY_SUMMARY } from '@/api';
import { FinancialSummaryComponent } from './FinancialSummary';

export const FinancialRecoveryScreen: React.FC = () => {
	const pathname = usePathname();
	const { replace } = useRouter();
	const searchParams = useSearchParams();
	const params = new URLSearchParams(searchParams);
	const filterValue = params.get('year') || undefined;

	const { data: summary } = useQuery({
		queryKey: [GET_RECOVERY_SUMMARY, filterValue],
		queryFn: () =>
			financialRecoveryService.getSummary({
				year: filterValue ? Number(filterValue) : undefined,
			}),
	});

	const handleFilter = (value: string | undefined) => {
		if (value === 'clear-all') {
			replace(`${pathname}`);
			return;
		}
		if (value) {
			params.set('year', value);
		} else {
			params.delete('year');
		}

		replace(`${pathname}?${params.toString()}`);
	};

	return (
		<main className="flex flex-col gap-4 lg:gap-6">
			<FinancialFilter
				handleFilter={handleFilter}
				filterValue={params.get('year') || undefined}
				paramSize={params.size}
			/>
			<FinancialSummaryComponent summary={summary?.data} />
			<FinancialCasesList filterValue={params.get('year') || undefined} />
		</main>
	);
};
